import { useDynamicQueryResource } from '@subtile/project-shared';
import document, { type WalletsVars } from '../queries/walletsQuery';
import type { Wallet } from '../types';

export default (variables: WalletsVars) =>
  useDynamicQueryResource<Wallet[], WalletsVars>(document, variables);
